// extracted by mini-css-extract-plugin
export const amount = "LineChartLegend__amount__71kja font-faces__sansSemibold__K6NQF font-faces__sans__uCf65";
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const chartLineLegend = "LineChartLegend__chartLineLegend__X7+H- font-faces__sansMedium__DqLMY font-faces__sans__uCf65";
export const dashed = "LineChartLegend__dashed__iyX95";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const label = "LineChartLegend__label__kDcx4";
export const line = "LineChartLegend__line__9iwMV";
export const medium = "500";
export const member = "LineChartLegend__member__WE4gN";
export const regular = "400";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";
export const solid = "LineChartLegend__solid__tXt9o";